import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';

const StepperConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: { borderColor: 'primary.light' },
  },

  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: { borderColor: 'primary.light' },
  },

  [`&.${stepConnectorClasses.disabled} .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.grey[300],
  },

  [`& .${stepConnectorClasses.line}`]: {
    borderColor: 'grey.300',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

export default StepperConnector;
